/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** User feature flags */
export interface UserFlags {
  /** Whether mana generation rate has been recalculated */
  manaRecalculated?: boolean;
}

/** User energy information */
export interface Energy {
  /** Current energy level */
  current: number;
  /** Maximum energy level */
  max: number;
  /** Time in ms until next energy point restores */
  nextRestore: number;
  /** Time in ms until full energy restores */
  fullRestore: number;
}

/** User mana information */
export interface Mana {
  /** Current mana amount */
  current: number;
  /** Time in ms until next mana point generates */
  nextGeneration: number;
  /** Whether mana is currently generating */
  isGenerating: boolean;
  /** Time in ms until user needs to manually recharge */
  nextRechargeNeeded: number;
  /** Mana generation rate per day */
  generationRate: number;
}

export interface UserMax {
  /** User ID */
  id: number;
  /** User first name */
  firstName: string;
  /** User second name */
  secondName?: string | null;
  /** User username */
  username?: string | null;
  /** User balance */
  balance: number;
  /** User EVL currency (accumulate-only) */
  evl: number;
  /** User USDT currency */
  usdt: number;
  /** User last login date in ISO format */
  lastLoginAt: string;
  /** User feature flags */
  userFlags: UserFlags;
  /** User energy information */
  energy: Energy;
  /** User mana information */
  mana: Mana;
}

export interface UserRank {
  /** User ID */
  id: number;
  /** User first name */
  firstName: string;
  /** User second name */
  secondName?: string | null;
  /** User username */
  username?: string | null;
  /** User EVL currency (accumulate-only) */
  evl: number;
  /** User rank in the leaderboard */
  rank: number;
}

/** Array of users with rank information */
export type UserRankArray = UserRank[];

export interface InviteStats {
  /** Number of users invited by the user */
  usersInvited: number;
  /** Next bonus amount based on user activity */
  nextBonus: number;
  /** Total earnings from user invitations */
  earned: number;
}

export interface Objective {
  /** Objective localized description */
  description?: string;
  /** Objective localization key */
  descriptionKey: string;
  /** Prize for completing the objective */
  prize: number;
  /** Value required to complete the objective */
  requiredValue: number;
  /** Current progress towards the objective */
  progress: number;
  /** Whether the objective is completed */
  completed: boolean;
}

export interface Stage {
  /** Stage ID */
  id: string;
  /** Image placeholder name */
  image: string;
  /** Stage localized title */
  title?: string;
  /** Stage localization key */
  titleKey: string;
  /** Stage localized description */
  description?: string;
  /** Stage localization key for description */
  descriptionKey: string;
  /** Whether the stage is unlocked */
  unlocked: boolean;
  /** List of objectives for the stage */
  objectives?: Objective[];
  /** Mana bonus percentage for completing the stage */
  manaBonus: number;
}

/** Array of stages */
export type StageArray = Stage[];

export interface RewardReference {
  /** Encrypted ID of the game element */
  id: string;
  /** Value associated with the game element */
  value: number;
}

export interface CaravanElement {
  /** Type of the caravan element */
  type: "regular" | "special";
  /** Value of the caravan element */
  value: number;
  /** Special value for special type elements */
  specialValue?: number;
  /** Special gift for special type elements */
  specialGift?: "apples" | "magnet";
}

/** Caravan with pool of elements and maximum coin value */
export interface Caravan {
  /** Encrypted ID of the caravan */
  id: string;
  /** Maximum coins available in the caravan */
  value: number;
  /** Pool of caravan elements */
  pool: CaravanElement[];
}

export interface StageInitData {
  /** Run ID of the initialized stage */
  runId: string;
  /** List of bosses with their IDs and values */
  bosses: RewardReference[];
  /** List of treasures with their IDs and values */
  treasures: RewardReference[];
  /** Endgame reference ID and value */
  endgame: RewardReference;
  /** Max gift coins reference ID and value */
  giftCoins: RewardReference;
  /** Caravan with pool of elements and maximum coin value */
  caravan: Caravan;
}

export interface ClaimRewardResponse {
  /** Whether the reward claim was successful */
  success: boolean;
}

export interface ClaimRewardRequest {
  /**
   * Encrypted ID of the game element to claim
   * @minLength 1
   */
  id: string;
  /** Optional value associated with the game element */
  value?: number;
}

/** Character upgrade characteristic */
export enum CharacteristicEnum {
  MaxHp = "maxHp",
  MoveSpeed = "moveSpeed",
  Power = "power",
  Area = "area",
  Speed = "speed",
  Duration = "duration",
  Cooldown = "cooldown",
  Luck = "luck",
  Growth = "growth",
  Amount = "amount",
  Magnet = "magnet",
}

export interface CharacteristicDefault {
  /** Character upgrade characteristic */
  characteristic: CharacteristicEnum;
  /** Base value of the characteristic */
  baseValue: number;
  /** Optional description */
  description?: string;
  /** Localization key for description */
  descriptionKey: string;
}

export interface CharacteristicUpgrade {
  /** Upgrade level */
  level: number;
  /** Cost to upgrade to this level */
  cost: number;
  /** Value increment when upgrading to this level */
  increment: number;
}

export interface UpgradesInfo {
  /** Default values for each characteristic */
  defaults: {
    maxHp?: CharacteristicDefault;
    moveSpeed?: CharacteristicDefault;
    power?: CharacteristicDefault;
    area?: CharacteristicDefault;
    speed?: CharacteristicDefault;
    duration?: CharacteristicDefault;
    cooldown?: CharacteristicDefault;
    luck?: CharacteristicDefault;
    growth?: CharacteristicDefault;
    amount?: CharacteristicDefault;
    magnet?: CharacteristicDefault;
  };
  /** Available upgrades for each characteristic */
  upgrades: {
    maxHp?: CharacteristicUpgrade[];
    moveSpeed?: CharacteristicUpgrade[];
    power?: CharacteristicUpgrade[];
    area?: CharacteristicUpgrade[];
    speed?: CharacteristicUpgrade[];
    duration?: CharacteristicUpgrade[];
    cooldown?: CharacteristicUpgrade[];
    luck?: CharacteristicUpgrade[];
    growth?: CharacteristicUpgrade[];
    amount?: CharacteristicUpgrade[];
    magnet?: CharacteristicUpgrade[];
  };
  /** Current level of each characteristic for the user */
  currentLevels: {
    maxHp?: number;
    moveSpeed?: number;
    power?: number;
    area?: number;
    speed?: number;
    duration?: number;
    cooldown?: number;
    luck?: number;
    growth?: number;
    amount?: number;
    magnet?: number;
  };
  /** Current stats after applying upgrades */
  currentStats?: {
    maxHp?: number;
    moveSpeed?: number;
    power?: number;
    area?: number;
    speed?: number;
    duration?: number;
    cooldown?: number;
    luck?: number;
    growth?: number;
    amount?: number;
    magnet?: number;
  };
}

export interface UpgradeResponse {
  /** Upgraded characteristic */
  characteristic: CharacteristicEnum;
  /** New level after upgrade */
  level: number;
  /** User balance after upgrade */
  balance: number;
}

export interface UpgradeRequest {
  /** Characteristic to upgrade */
  characteristic: CharacteristicEnum;
}

/** Type of the boost */
export enum BoostTypeEnum {
  Heal = "heal",
  Revive = "revive",
  Explosion = "explosion",
  Doubling = "doubling",
  EnergyOne = "energy_one",
  EnergyFull = "energy_full",
}

export interface UserBoost {
  /** Type of the boost */
  type: BoostTypeEnum;
  /** Number of boosts of this type */
  count: number;
  /** Price of the boost */
  price: number;
}

export interface UserBoosts {
  /** Array of available boosts */
  boosts: UserBoost[];
}

export interface BoostBuyResponse {
  /** URL to the payment invoice */
  invoiceUrl: string;
}

export interface BoostRequest {
  /** Type of the boost to purchase or use */
  boostType: BoostTypeEnum;
  /** Unique identifier of the game run */
  runId?: string;
}

export interface BoostUseResponse {
  /** Whether the boost was successfully activated */
  success: boolean;
}

/** Type of the task */
export enum TaskTypeEnum {
  SC = "SC",
  IF = "IF",
  FL = "FL",
  US = "US",
  BL = "BL",
  BB = "BB",
  AI = "AI",
  DR = "DR",
  KB = "KB",
  SL = "SL",
}

/** Group of the task */
export enum TaskGroupEnum {
  DAILY = "DAILY",
  SOCIAL = "SOCIAL",
  GAME = "GAME",
  COMPLETED = "COMPLETED",
}

export interface UserTask {
  /** Unique task identifier */
  id: string;
  /** Type of the task */
  type: TaskTypeEnum;
  /** Group of the task */
  group: TaskGroupEnum;
  /** External reference ID for the task */
  externalId?: string;
  /** Prize amount for completing the task */
  prize: number;
  /** Next prize amount for the task */
  nextPrize?: number;
  /** Whether the user has completed this task */
  completed: boolean;
  /** Task localized description */
  description?: string;
  /** Task localization key */
  descriptionKey: string;
}

/** List of tasks with completion status */
export type UserTaskArray = UserTask[];

export interface TaskListResponse {
  /** List of tasks with completion status */
  tasks: UserTaskArray;
}

export interface TaskCheckResponse {
  /** Whether the task was successfully completed */
  success: boolean;
}

/** ID of the task to check completion status */
export enum TaskIdEnum {
  SCEC = "SC:EC",
  SCECC = "SC:ECC",
  IF1 = "IF:1",
  FL1 = "FL:1",
  FL3 = "FL:3",
  FL5 = "FL:5",
  US1 = "US:1",
  US5 = "US:5",
  US10 = "US:10",
  BL1 = "BL:1",
  BB1 = "BB:1",
  AIEC = "AI:EC",
  DR = "DR",
  DAILY_REWARD = "DAILY_REWARD",
  DKB1 = "DKB:1",
  DSL1 = "DSL:1",
  DIF1 = "DIF:1",
}

export interface TaskCheckRequest {
  /** ID of the task to check completion status */
  taskId: TaskIdEnum;
}

export interface ObjectiveActualizationResponse {
  /** Whether the actualization was successful */
  success: boolean;
  /** Number of new objectives inserted */
  inserted: number;
  /** Number of objectives marked as deleted */
  deleted: number;
  /** Number of objectives that remained unchanged */
  unchanged: number;
}

/** Look identifier from the enum */
export enum LookIdEnum {
  BASIC = "BASIC",
  BLUE_GIRL = "BLUE_GIRL",
  PHANTOM = "PHANTOM",
  MAN_IN_MASK = "MAN_IN_MASK",
  GREEN_GIRL = "GREEN_GIRL",
  WISE_MAGE = "WISE_MAGE",
  PUNK = "PUNK",
  MAN_IN_BLUE = "MAN_IN_BLUE",
  EVIL_ORC = "EVIL_ORC",
  BONE_MASK = "BONE_MASK",
}

export interface LookInfo {
  /** Look identifier from the enum */
  id: LookIdEnum;
  /** Key for the look sprite in the game */
  spriteKey: string;
  /** Key for the look animation in the game */
  animationKey?: string;
  /** Localization key for the look name */
  nameKey: string;
  /** Rarity level of the look */
  rarity: string;
  /** Price of the look in Stars */
  price: number;
  /** Discounted price of the look in Stars */
  discountPrice?: number;
  /** Character stat upgrades provided by this look */
  characteristicsUpgrades: Record<string, number>;
  /** Whether the user owns this look */
  isOwned: boolean;
  /** Whether the look is selected by the user */
  isSelected: boolean;
}

export interface LooksResponse {
  /** List of available looks with ownership status */
  looks: LookInfo[];
}

export interface SelectedLookResponse {
  /** Currently selected look or null if none selected */
  look: LookInfo;
}

export interface SelectLookResponse {
  /** Whether the look selection was successful */
  success: boolean;
}

export interface LookBuyResponse {
  /** URL to the payment invoice */
  invoiceUrl: string;
}

/** Pack identifier from the enum */
export enum PackIdEnum {
  BASICBOOSTS3 = "BASIC_BOOSTS_3",
  BASICBOOSTS6 = "BASIC_BOOSTS_6",
  BASICBOOSTS9 = "BASIC_BOOSTS_9",
  HEAL10 = "HEAL_10",
  REVIVE10 = "REVIVE_10",
  EXPLOSION10 = "EXPLOSION_10",
}

/** Coin bundle identifier from the enum */
export enum CoinBundleIdEnum {
  COINS1K = "COINS_1K",
  COINS2K = "COINS_2K",
  COINS5K = "COINS_5K",
  COINS10K = "COINS_10K",
  COINS20K = "COINS_20K",
  COINS50K = "COINS_50K",
  COINS100K = "COINS_100K",
  COINS300K = "COINS_300K",
  COINS1M = "COINS_1M",
}

export interface PurchaseResponse {
  /** Array of available boosts */
  boosts: UserBoost[];
  /** Array of available looks */
  looks: LookInfo[];
  /** Array of available packs */
  packs: {
    /** Pack identifier from the enum */
    id: PackIdEnum;
    /** Localization key for the pack name */
    nameKey: string;
    /** Price of the pack in Stars */
    price: number;
    /** Discounted price of the pack in Stars */
    discountPrice?: number;
    /** Items included in the pack */
    items: {
      /** Number of boosts in the pack */
      boosts?: {
        heal?: number;
        revive?: number;
        explosion?: number;
        doubling?: number;
        energy_one?: number;
        energy_full?: number;
      };
      /** Looks included in the pack */
      looks?: LookIdEnum[];
    };
  }[];
  /** Array of available coin bundles */
  coinBundles: {
    /** Coin bundle identifier from the enum */
    id: CoinBundleIdEnum;
    /** Localization key for the coin bundle name */
    nameKey: string;
    /** Price of the coin bundle in Stars */
    price: number;
    /** Discounted price of the coin bundle in Stars */
    discountPrice?: number;
    /** Amount of coins in the bundle */
    amount: number;
    /** Extra amount of coins in the bundle */
    extraAmount?: number;
  }[];
}

export interface PurchaseBuyResponse {
  /** URL to the payment invoice */
  invoiceUrl: string;
}

export interface PurchaseRequest {
  /** Type of the boost to purchase */
  boostType?: BoostTypeEnum;
  /** ID of the look to purchase */
  lookId?: LookIdEnum;
  /** ID of the pack to purchase */
  packId?: PackIdEnum;
  /** ID of the coin bundle to purchase */
  coinBundleId?: CoinBundleIdEnum;
}

/** Type of recharge interval */
export enum RechargeIntervalTypeEnum {
  Single = "single",
  Day = "day",
  Value3Days = "3days",
  Value5Days = "5days",
}

export interface RechargeOption {
  /** Type of recharge interval */
  type: RechargeIntervalTypeEnum;
  /** Duration of recharge interval in milliseconds */
  duration: number;
  /** Price per mana per day for this recharge type */
  pricePerManaPerDay: number;
  /** Total price for this recharge option based on user generation rate */
  totalPrice: number;
}

export interface RechargeOptionsResponse {
  /** Available recharge options */
  options: RechargeOption[];
}

export interface ManaRewardOption {
  /** Type of reward option */
  type: "EVL" | "USDT" | "MANA" | "COINS" | "ENERGY" | "PACK_BOOSTS" | "HEAL_BOOST" | "EXPLOSION_BOOST" | "RANDOM_LOOK";
}

export interface ManaRewardVisualizationResponse {
  /** Options for visualization (types only, no amounts) */
  options: ManaRewardOption[];
}

export interface ManaRechargeRequest {
  /** Type of recharge interval (defaults to single) */
  rechargeType?: RechargeIntervalTypeEnum;
}

/** The actual reward received */
export interface ManaReward {
  /** Type of reward received */
  type: "EVL" | "USDT" | "MANA" | "COINS" | "ENERGY" | "PACK_BOOSTS" | "HEAL_BOOST" | "EXPLOSION_BOOST" | "RANDOM_LOOK";
  /** Amount of the reward */
  amount: number;
  /** Specific ID for rewards like looks */
  specificId?: string;
}

export interface SingleManaRewardResponse {
  /** The actual reward received */
  reward: ManaReward;
}

export interface MultipleManaRewardResponse {
  /** Array of rewards received */
  rewards: ManaReward[];
}

export interface ManaRewardRequest {
  /** Amount of mana to convert */
  manaAmount: "1" | "5" | "10" | "50";
}

export interface StageCompletionResponse {
  /** Whether the user has completed the stage */
  completed: boolean;
}

/** Stage ID to check completion status */
export enum StageIdEnum {
  D1 = "D1",
  D2 = "D2",
  D3 = "D3",
  D4 = "D4",
  D5 = "D5",
  D6 = "D6",
  D7 = "D7",
  D8 = "D8",
  D9 = "D9",
  D10 = "D10",
  D11 = "D11",
  J1 = "J1",
  J2 = "J2",
  J3 = "J3",
  C1 = "C1",
  C2 = "C2",
  C3 = "C3",
  CP1 = "CP1",
  CP2 = "CP2",
  CP3 = "CP3",
  M1 = "M1",
  M2 = "M2",
  M3 = "M3",
}

/** Book identifier from the enum */
export enum BookIdEnum {
  BASIC_MAGIC_BOOK = "BASIC_MAGIC_BOOK",
  BOOK_OF_FIRE = "BOOK_OF_FIRE",
  BOOK_OF_ICE = "BOOK_OF_ICE",
  THE_NECRONOMICON = "THE_NECRONOMICON",
  THE_KAMA_SUTRA = "THE_KAMA_SUTRA",
  COMIC_BOOK = "COMIC_BOOK",
  THE_ART_OF_WAR = "THE_ART_OF_WAR",
  INDIES_DIARY = "INDIES_DIARY",
  THE_ADVENTURES_OF_SHERLOCK_HOLMES = "THE_ADVENTURES_OF_SHERLOCK_HOLMES",
  THE_ODYSSEY = "THE_ODYSSEY",
  THE_ARABIAN_NIGHTS = "THE_ARABIAN_NIGHTS",
  THE_BHAGAVAD_GITA = "THE_BHAGAVAD_GITA",
}

/** Rarity level of the book */
export enum BookRarityEnum {
  Common = "common",
  Rare = "rare",
  Epic = "epic",
  Legendary = "legendary",
  Mythic = "mythic",
}

export interface BookInfo {
  /** Book identifier from the enum */
  id: BookIdEnum;
  /** Key for the book image */
  imageKey: string;
  /** Localization key for the book name */
  nameKey: string;
  /** Rarity level of the book */
  rarity: BookRarityEnum;
  /** Price of the book in coins */
  price: number;
  /** Mana generation increase per day */
  manaGenerationIncrement: number;
  /** When the book becomes available for purchase */
  availabilityStart?: string;
  /** When the book stops being available for purchase */
  availabilityEnd?: string;
  /** Whether the user owns this book */
  isOwned: boolean;
  /** Whether the book is currently available for purchase */
  isAvailable: boolean;
}

export interface BooksResponse {
  /** Array of available books */
  books: BookInfo[];
}

export interface BookBuyResponse {
  /** Whether the purchase was successful */
  success: boolean;
}

import type { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "/" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title TON Survivors Backend API
 * @version 1.0.0
 * @baseUrl /
 *
 * API documentation for TON Survivors backend
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * @description Initialize webapp for a user: returns existing user (200) or creates a new user (201).
     *
     * @tags Webapp
     * @name WebappInitCreate
     * @request POST:/api/webapp/init
     * @secure
     */
    webappInitCreate: (params: RequestParams = {}) =>
      this.request<UserMax, any>({
        path: `/api/webapp/init`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current user information
     *
     * @tags User
     * @name UsersList
     * @request GET:/api/users
     * @secure
     */
    usersList: (params: RequestParams = {}) =>
      this.request<UserMax, any>({
        path: `/api/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user leaderboard based on EVL rankings
     *
     * @tags User
     * @name UsersLeaderboardList
     * @request GET:/api/users/leaderboard
     * @secure
     */
    usersLeaderboardList: (params: RequestParams = {}) =>
      this.request<UserRankArray, any>({
        path: `/api/users/leaderboard`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get invite statistics including users invited count and next bonus amount
     *
     * @tags User
     * @name UsersInviteStatsList
     * @request GET:/api/users/invite-stats
     * @secure
     */
    usersInviteStatsList: (params: RequestParams = {}) =>
      this.request<InviteStats, any>({
        path: `/api/users/invite-stats`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available stages
     *
     * @tags Stages
     * @name StagesList
     * @request GET:/api/stages
     * @secure
     */
    stagesList: (params: RequestParams = {}) =>
      this.request<StageArray, any>({
        path: `/api/stages`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get stage initialization data including reference IDs for game elements
     *
     * @tags Stages
     * @name StagesInitList
     * @request GET:/api/stages/{stageId}/init
     * @secure
     */
    stagesInitList: (
      stageId: string,
      query?: {
        /**
         * Whether to disable encryption for stage data
         * @default false
         */
        encryptionDisabled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<StageInitData, any>({
        path: `/api/stages/${stageId}/init`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get objectives for a specific stage
     *
     * @tags Stages
     * @name StagesObjectivesList
     * @request GET:/api/stages/{stageId}/objectives
     * @secure
     */
    stagesObjectivesList: (stageId: string, params: RequestParams = {}) =>
      this.request<Objective[], any>({
        path: `/api/stages/${stageId}/objectives`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Claim a reward from a game element using its encrypted ID
     *
     * @tags Rewards
     * @name RewardsClaimCreate
     * @request POST:/api/rewards/claim
     * @secure
     */
    rewardsClaimCreate: (data: ClaimRewardRequest, params: RequestParams = {}) =>
      this.request<ClaimRewardResponse, any>({
        path: `/api/rewards/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get available upgrades and user's current levels
     *
     * @tags Upgrades
     * @name UpgradesList
     * @request GET:/api/upgrades
     * @secure
     */
    upgradesList: (params: RequestParams = {}) =>
      this.request<UpgradesInfo, any>({
        path: `/api/upgrades`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Upgrade a specific characteristic
     *
     * @tags Upgrades
     * @name UpgradesCreate
     * @request POST:/api/upgrades
     * @secure
     */
    upgradesCreate: (data: UpgradeRequest, params: RequestParams = {}) =>
      this.request<UpgradeResponse, any>({
        path: `/api/upgrades`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get available boosts for the user
     *
     * @tags Boosts
     * @name BoostsList
     * @request GET:/api/boosts
     * @secure
     */
    boostsList: (params: RequestParams = {}) =>
      this.request<UserBoosts, any>({
        path: `/api/boosts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Purchase a boost
     *
     * @tags Boosts
     * @name BoostsBuyCreate
     * @request POST:/api/boosts/buy
     * @secure
     */
    boostsBuyCreate: (data: BoostRequest, params: RequestParams = {}) =>
      this.request<BoostBuyResponse, any>({
        path: `/api/boosts/buy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Activate a boost
     *
     * @tags Boosts
     * @name BoostsUseCreate
     * @request POST:/api/boosts/use
     * @secure
     */
    boostsUseCreate: (data: BoostRequest, params: RequestParams = {}) =>
      this.request<BoostUseResponse, any>({
        path: `/api/boosts/use`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available tasks with completion status
     *
     * @tags Tasks
     * @name TasksList
     * @request GET:/api/tasks
     * @secure
     */
    tasksList: (params: RequestParams = {}) =>
      this.request<TaskListResponse, any>({
        path: `/api/tasks`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Check completion status for a task and claim reward if completed
     *
     * @tags Tasks
     * @name TasksCheckCreate
     * @request POST:/api/tasks/check
     * @secure
     */
    tasksCheckCreate: (data: TaskCheckRequest, params: RequestParams = {}) =>
      this.request<TaskCheckResponse, any>({
        path: `/api/tasks/check`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Actualizes objectives in the database based on game configuration
     *
     * @tags Objectives
     * @name ObjectivesActualizeCreate
     * @request POST:/api/objectives/actualize
     * @secure
     */
    objectivesActualizeCreate: (params: RequestParams = {}) =>
      this.request<ObjectiveActualizationResponse, any>({
        path: `/api/objectives/actualize`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available looks (except secret ones) with ownership info
     *
     * @tags Looks
     * @name LooksList
     * @request GET:/api/looks
     * @secure
     */
    looksList: (params: RequestParams = {}) =>
      this.request<LooksResponse, any>({
        path: `/api/looks`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get the currently selected look for the user
     *
     * @tags Looks
     * @name LooksSelectedList
     * @request GET:/api/looks/selected
     * @secure
     */
    looksSelectedList: (params: RequestParams = {}) =>
      this.request<SelectedLookResponse, any>({
        path: `/api/looks/selected`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Select a look for the user
     *
     * @tags Looks
     * @name LooksSelectCreate
     * @request POST:/api/looks/{lookId}/select
     * @secure
     */
    looksSelectCreate: (lookId: string, params: RequestParams = {}) =>
      this.request<SelectLookResponse, any>({
        path: `/api/looks/${lookId}/select`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Buy a look or select it if already owned by the user
     *
     * @tags Looks
     * @name LooksBuyCreate
     * @request POST:/api/looks/{lookId}/buy
     * @secure
     */
    looksBuyCreate: (lookId: string, params: RequestParams = {}) =>
      this.request<LookBuyResponse, any>({
        path: `/api/looks/${lookId}/buy`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available purchases (boosts, looks, packs)
     *
     * @tags Purchases
     * @name PurchasesList
     * @request GET:/api/purchases
     * @secure
     */
    purchasesList: (params: RequestParams = {}) =>
      this.request<PurchaseResponse, any>({
        path: `/api/purchases`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Buy a boost, look, or pack
     *
     * @tags Purchases
     * @name PurchasesBuyCreate
     * @request POST:/api/purchases/buy
     * @secure
     */
    purchasesBuyCreate: (data: PurchaseRequest, params: RequestParams = {}) =>
      this.request<PurchaseBuyResponse, any>({
        path: `/api/purchases/buy`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get current user mana status
     *
     * @tags Mana
     * @name ManaList
     * @request GET:/api/mana
     * @secure
     */
    manaList: (params: RequestParams = {}) =>
      this.request<Mana, any>({
        path: `/api/mana`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get available mana recharge options with prices
     *
     * @tags Mana
     * @name ManaRechargeOptionsList
     * @request GET:/api/mana/recharge-options
     * @secure
     */
    manaRechargeOptionsList: (params: RequestParams = {}) =>
      this.request<RechargeOptionsResponse, any>({
        path: `/api/mana/recharge-options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get available reward types for visualization (without amounts)
     *
     * @tags Mana
     * @name ManaRewardOptionsList
     * @request GET:/api/mana/reward-options
     * @secure
     */
    manaRewardOptionsList: (params: RequestParams = {}) =>
      this.request<ManaRewardVisualizationResponse, any>({
        path: `/api/mana/reward-options`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Recharge mana generation for a specified duration
     *
     * @tags Mana
     * @name ManaRechargeCreate
     * @request POST:/api/mana/recharge
     * @secure
     */
    manaRechargeCreate: (data: ManaRechargeRequest, params: RequestParams = {}) =>
      this.request<Mana, any>({
        path: `/api/mana/recharge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Convert mana to rewards. Returns single reward for 1 mana, or array of rewards for multiple mana
     *
     * @tags Mana
     * @name ManaConvertCreate
     * @request POST:/api/mana/convert
     * @secure
     */
    manaConvertCreate: (data: ManaRewardRequest, params: RequestParams = {}) =>
      this.request<SingleManaRewardResponse | MultipleManaRewardResponse, any>({
        path: `/api/mana/convert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Simple hello endpoint to test partner authentication
     *
     * @tags Partners
     * @name PartnersHelloList
     * @request GET:/api/partners/hello
     * @secure
     */
    partnersHelloList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/api/partners/hello`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Check if a user has completed a specific stage
     *
     * @tags Partners
     * @name PartnersStageCompletionList
     * @request GET:/api/partners/stage-completion
     * @secure
     */
    partnersStageCompletionList: (
      query: {
        userId: string;
        /** Stage ID to check completion status */
        stageId: StageIdEnum;
      },
      params: RequestParams = {},
    ) =>
      this.request<StageCompletionResponse, any>({
        path: `/api/partners/stage-completion`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get all available books for the user
     *
     * @tags Books
     * @name BooksList
     * @request GET:/api/books
     * @secure
     */
    booksList: (params: RequestParams = {}) =>
      this.request<BooksResponse, any>({
        path: `/api/books`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Buy a book with coins
     *
     * @tags Books
     * @name BooksBuyCreate
     * @request POST:/api/books/{bookId}/buy
     * @secure
     */
    booksBuyCreate: (bookId: string, params: RequestParams = {}) =>
      this.request<BookBuyResponse, any>({
        path: `/api/books/${bookId}/buy`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
